export const getColorArray = (data, config) => {
  const { limitsArray = [], colorsArray = [] } = config;
  const colors = [];

  for (let i = 0; i < data.length; i++) {
    if (data[i] >= limitsArray[0]) {
      colors.push(colorsArray[0]);
    } else if (data[i] < limitsArray[0] && data[i] >= limitsArray[1]) {
      colors.push(colorsArray[1]);
    } else if (data[i] < limitsArray[1] && data[i] >= limitsArray[2]) {
      colors.push(colorsArray[2]);
    } else if (data[i] < limitsArray[2] && data[i] >= limitsArray[3]) {
      colors.push(colorsArray[3]);
    }
  }
  return colors;
};
